import { Button, Col, Divider, Dropdown, Menu, Row } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons';
import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import { useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import api from '../utils/apiRoutes';
import GlobalLoading from '../Containers/GlobalLoading';

const Circle = ({ percent, color }) => {
  const radius = 20; // Radius of the circle
  const strokeWidth = 8; // Width of the stroke
  const circumference = 2 * Math.PI * radius; // Circumference of the circle

  // Calculate the dash offset based on the percentage
  const dashOffset = ((100 - percent) / 100) * circumference;

  return (
    <svg width={radius * 2} height={radius * 2} viewBox={`0 0 ${radius * 2} ${radius * 2}`} style={{rotate:'-90deg'}}>
      <circle
        cx={radius}
        cy={radius}
        r={radius - strokeWidth / 2}
        fill="none"
        stroke="#E6E7E6"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={radius}
        cy={radius}
        r={radius - strokeWidth / 2}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        strokeLinecap="round"
      />
    </svg>
  );
}

function ClaimAmount() {

  const [filters, setFilters] = useState({ date: '', location: '' });
  const [stats, set_stats] = useState([]);
  const [loading, setLoading] = useState(false);

  const onClickDate = (e) => {
    // console.log(e.key, 'here');
    setFilters({ ...filters, date: e.key });
  };
  const onClickLocation = (e) => {
    // console.log(e.key, 'here');
    setFilters({ ...filters, location: e.key });
  };

  useEffect(() => {
    const headers = { 'Authorization': `Bearer ${Cookies.get('token_medical_auth')}` }
    setLoading(true);

    api.patientsStats.getClaimAmount({}, headers, filters).then(res => {
      set_stats((res || []));
      setLoading(false);
    }).catch(err => {
      // console.log(err);
      setLoading(false);
    })

  }, [filters])

  const menu = (
    <Menu
      onClick={onClickDate}
      items={[
        {
          key: '',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              All dates
            </a>
          ),
        },
        {
          key: 'Today',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Today
            </a>
          ),
        },
        {
          key: 'This week',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com" onClick={(e) => { e.preventDefault() }}>
              This week
            </a>
          ),
        },
        {
          key: 'This month',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.luohanacademy.com" onClick={(e) => { e.preventDefault() }}>
              This month
            </a>
          ),
        },
      ]}
    />
  );

  const menuLocation = (
    <Menu
      onClick={onClickLocation}
      items={[
        {
          key: '',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              All locations
            </a>
          ),

        },
        {
          key: 'Delhi',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Delhi
            </a>
          ),

        },
        {
          key: 'Mumbai',
          label: (
            <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com" onClick={(e) => { e.preventDefault() }}>
              Mumbai
            </a>
          ),

        }
      ]}
    />
  );


  const options = {
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        bodyFont: {
          size: 18
        },
        padding: 15,
        titleAlign: 'center',
        // bodyAlign: 'center',
        titleMarginBottom: 10,
        titleFont: {
          size: 18
        },
        boxPadding: 10,
        callbacks: {
          label: function(context) {
            return `₹${context.formattedValue}`
          },
          title: function(context) {
            return context[0].label
          }
        }
      }
    },
    cutout: 95
  }

  const data = {
    labels: ['Actual Amount Processed', 'Total Claim Amount', 'Final Approved Amount'],
    datasets: [
      {
        data: [stats.amountProcessed, stats.totalClaimAmount, stats.amountApproved ],
        backgroundColor: [
          '#2257BA',
          '#F3AE47',
          '#49AF97',
        ],
        borderWidth: 0,
        pointBorderWidth: 1,
        pointHoverRadius: 5,
      },
    ],
  };

  if (loading) return <GlobalLoading />
  return (
    <div className="claim-amount-container">
      <div className="claim-amount-box">
        <div className='top-bar'>
          <h3>Total Claim Amount</h3>
          <Dropdown overlay={menu} placement="bottom" getPopupContainer={trigger => trigger.parentElement}>
            <Button>{filters.date === '' ? 'Date' : filters.date} <CaretDownOutlined style={{color:'#3788E5'}}/></Button>
          </Dropdown>
        </div>
        {/* <Row>
          <Col className="indicators" span={20}>
            <div className="indicators-container">
              <i className="color orange" />
              Total Claim Amount
            </div>
            <div className="indicators-container">
              <i className="color green" />
              Final Approved Amount
            </div>
            <div className="indicators-container">
              <i className="color blue" />
              Actual Amount Processed
            </div>
          </Col>
          <Col className="drop-btns-container" span={4}>

            <Row justify='end'>
              <Col style={{ marginRight: 5 }}>
                <Dropdown overlay={menu} placement="bottom">
                  <Button>{filters.date === '' ? 'Date' : filters.date} <CaretDownOutlined /></Button>
                </Dropdown>
              </Col> */}
              {/* <Col>
                <Dropdown overlay={menuLocation} placement="bottom">
                  <Button>{filters.location === '' ? 'Location' : filters.location} <CaretDownOutlined /></Button>
                </Dropdown>
              </Col> */}
            {/* </Row>

          </Col>
        </Row>
        <Divider /> */}
        <Row align='middle'>
          <Col span={12}>
            <Doughnut className="stats-donut" options={options} data={data} />
          </Col>
          <Col className="stats-info-container" span={12}>
            <div className="stats-info">
              <div className='stats-heading'>
                <div>
                  Actual Amount Processed
                  <p className="blue">₹ {stats.amountProcessed?.toLocaleString('en-IN')}</p>
                </div>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                  <Circle percent={ (stats.amountProcessed>0) ? 100/(1+(stats.totalClaimAmount/stats.amountProcessed)+(stats.amountApproved/stats.amountProcessed)) : 0 } color='#2257BA'/>
                  <span style={{color:'#2257BA', fontSize:'12px', fontWeight:'700', marginTop:'0.5rem'}}>{ (stats.amountProcessed>0) ? Math.round(100/(1+(stats.totalClaimAmount/stats.amountProcessed)+(stats.amountApproved/stats.amountProcessed))*100)/100 : 0 }%</span>
                </div>
              </div>
              <div className='percent-bar'>
                <div style={{backgroundColor:'#2257BA',height:'0.5rem', borderRadius:'10px',
                width:`${ (stats.amountProcessed>0) ? Math.round(100/(1+(stats.totalClaimAmount/stats.amountProcessed)+(stats.amountApproved/stats.amountProcessed))*100)/100 : 0 }%`
                }}></div>
              </div>
            </div>

            <div className="stats-info">
              <div className='stats-heading'>
                <div>
                  Total Claim Amount
                  <p className="orange">₹ {stats.totalClaimAmount?.toLocaleString('en-IN')}</p>
                </div>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                  <Circle percent={ (stats.totalClaimAmount>0) ? 100/(1+(stats.amountProcessed/stats.totalClaimAmount)+(stats.amountApproved/stats.totalClaimAmount)) : 0 } color='#F3AE47'/>
                  <span style={{color:'#F3AE47', fontSize:'12px', fontWeight:'700', marginTop:'0.5rem'}}>{ (stats.totalClaimAmount>0) ? Math.round(100/(1+(stats.amountProcessed/stats.totalClaimAmount)+(stats.amountApproved/stats.totalClaimAmount))*100)/100 : 0 }%</span>
                </div>
              </div>
              <div className='percent-bar'>
                <div style={{backgroundColor:'#F3AE47',height:'0.5rem', borderRadius:'10px',
                width:`${ (stats.totalClaimAmount>0) ? Math.round(100/(1+(stats.amountProcessed/stats.totalClaimAmount)+(stats.amountApproved/stats.totalClaimAmount))*100)/100 : 0 }%`
                }}></div>
              </div>
            </div>

            <div className="stats-info">
              <div className='stats-heading'>
                <div>
                  Final Approved Amount
                  <p className="green">₹ {stats.amountApproved?.toLocaleString('en-IN')}</p>
                </div>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                  <Circle percent={ (stats.amountApproved>0) ? 100/(1+(stats.amountProcessed/stats.amountApproved)+(stats.totalClaimAmount/stats.amountApproved)) : 0 } color='#49AF97'/>
                  <span style={{color:'#49AF97', fontSize:'12px', fontWeight:'700', marginTop:'0.5rem'}}>{ (stats.amountApproved>0) ? Math.round(100/(1+(stats.amountProcessed/stats.amountApproved)+(stats.totalClaimAmount/stats.amountApproved))*100)/100 : 0 }%</span>
                </div>
              </div>
              <div className='percent-bar'>
                <div style={{backgroundColor:'#49AF97',height:'0.5rem', borderRadius:'10px',
                width:`${ (stats.amountApproved>0) ? Math.round(100/(1+(stats.amountProcessed/stats.amountApproved)+(stats.totalClaimAmount/stats.amountApproved))*100)/100 : 0 }%`
                }}></div>
              </div>
            </div>
            {/* <a>View Details</a> */}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default ClaimAmount